/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { headerStyle, panelStyle, triggerStyle } from "./styles";
import { useThis } from "./useThis";

import type { Props } from "./props";
import type { FC, PropsWithChildren } from "react";

/**
 * @description
 * レガシーブラウザでも height animation を効かせてる
 * レガシーブラウザをサポートする途端実装ハードルが跳ね上がるため chat gpt に実装させた
 * それ故全量を理解しきれてないため、改善点は多々ある可能性のある component
 */
export const Collapse: FC<PropsWithChildren<Props>> = (props) => {
  const {
    children,
    className,
    closeIcon,
    handleToggleOpenAndClose,
    isOpened,
    openIcon,
    title,
  } = props;
  const { containerRef, innerRef, panelId, panelRef, triggerId } =
    useThis(props);

  return (
    <div ref={containerRef} className={className} data-collapsible-ready="0">
      <header css={headerStyle}>
        {title}
        <button
          aria-controls={panelId}
          aria-expanded={isOpened}
          css={triggerStyle}
          id={triggerId}
          type="button"
          onClick={handleToggleOpenAndClose}
        >
          {isOpened ? closeIcon : openIcon}
        </button>
      </header>

      <div
        ref={panelRef}
        aria-labelledby={triggerId}
        css={panelStyle}
        id={panelId}
      >
        <div ref={innerRef}>{children}</div>
      </div>
    </div>
  );
};
